import * as React from 'react';
import styles from './styles.module.css';
import { UIText1 } from '../../../../typography';
import { clsx as cx } from 'clsx';
export var SuggestionTitleItem = /*#__PURE__*/React.forwardRef(function (props, iconRef) {
  return /*#__PURE__*/React.createElement("li", {
    className: cx(styles['item'], styles[props.variant]),
    role: "option",
    tabIndex: -1,
    "data-testid": "suggesttion-title-item"
  }, props.leftIcon && /*#__PURE__*/React.createElement("div", {
    ref: iconRef,
    className: styles['left-icon']
  }, props.leftIcon), /*#__PURE__*/React.createElement("div", {
    className: cx(styles['name'], styles[props.variant])
  }, /*#__PURE__*/React.createElement(UIText1, {
    display: "inline",
    fontWeight: "700"
  }, props.title)));
});
SuggestionTitleItem.displayName = 'SuggestionItem';